import spreeStore from '../store';

const LoaderUtils = {
    isLoading: () => {
        const { displayLoader } = spreeStore.getState();
        return displayLoader;
    },
};

export default LoaderUtils;



/** WEBPACK FOOTER **
 ** ./src/services/loader-utils.js
 **/